import {
  FacebookIcon,
  InstagramIcon,
  PinterestIcon,
  QuoraIcon,
  TikTokIcon,
  TwitchIcon,
  TwitterXIcon,
  YoutubeIcon,
} from "@ms/gatsby-theme";

import {
  FACEBOOK_URL,
  INSTAGRAM_URL,
  PINTEREST_URL,
  QUORA_URL,
  TIKTOK_URL,
  TWITCH_URL,
  TWITTER_URL,
  YOUTUBE_URL,
} from "@ms/gatsby-site/src/config/social";

import type { SocialLinkInterface } from "@/types/footer";
// TODO: import

export const socialLinks: SocialLinkInterface[] = [
  {
    title: "facebook",
    href: FACEBOOK_URL,
    Icon: FacebookIcon,
  },
  {
    title: "instagram",
    href: INSTAGRAM_URL,
    Icon: InstagramIcon,
  },
  {
    title: "X",
    href: TWITTER_URL,
    Icon: TwitterXIcon,
  },
  {
    title: "youtube",
    href: YOUTUBE_URL,
    Icon: YoutubeIcon,
  },
  {
    title: "pinterest",
    href: PINTEREST_URL,
    Icon: PinterestIcon,
  },
  {
    title: "tiktok",
    href: TIKTOK_URL,
    Icon: TikTokIcon,
  },
  {
    title: "quora",
    href: QUORA_URL,
    Icon: QuoraIcon,
  },
  {
    title: "twitch",
    href: TWITCH_URL,
    Icon: TwitchIcon,
  },
];
